{
  "back": "Zpět",
  "back_2": "Zpět",
  "back_answering": "Zpět k odpovídání",
  "cc": "Tato práce je licencována pod licencí Creative Commons 4.0 (CC BY-NC).",
  "conformation_benchmark": "Nejnovější benchmark bude stažen z internetu.",
  "conformation_incomplete_q": "Tento stav bude smazán. Uložte podrobné odpovědi na lokální disk, abyste mohli pokračovat později.",
  "conformation_internet": "Nejnovější dotazník bude stažen z internetu.",
  "conformation_internet2": "Data budou nahrána do databáze. Aplikace přepošle požadavek přes internet.",
  "continue": "Pokračovat",
  "download": "Stáhnout na lokální disk",
  "end": "Konec",
  "green": "Atribut je v kontextu vaší organizace zcela pravdivý.",
  "incomplete": "Některé otázky nebyly zodpovězeny!",
  "introduction": {
    "apply": "Po vyhodnocení všech tvrzení obdrží respondent okamžitý přehled o stavu systému řízení informační bezpečnosti své organizace ve formě souboru ke stažení a vizuálního grafu. Graf obsahuje deset dimenzí řízení informační bezpečnosti, které lze využít pro další plánování rozvoje řízení informační bezpečnosti organizace.",
    "contact": "Máte-li otázky, kontaktujte nás.",
    "data_processing": "Principy zpracování dat:",
    "data_processing_1": "* E-mailová adresa slouží pouze k informování účastníků o zveřejnění nové verze dotazníku nebo nových dat.",
    "data_processing_2": "* Název organizace je nezbytný k určení domény/sektoru, identifikaci duplicitních výsledků a sledování dynamiky výsledků při opakovaných hodnoceních.",
    "data_processing_3": "* Výsledky, zprůměrované podle úrovně vyspělosti bezpečnosti, jsou analyzovány a prezentovány bez uvedení názvů zúčastněných organizací.",
    "data_processing_4": "* Výsledky hodnocení v kontextu konkrétní organizace budou použity pouze anonymně. Průměrné výsledky na základě domény/sektoru, tj. oblasti činnosti a velikosti instituce, budou zveřejněny pouze v případě, že máme dostupné výsledky vyhodnocení alespoň z pěti organizací náležejících do příslušné domény/sektoru.",
    "data_processing_5": "* Ve spolupráci s Estonským národním centrem kybernetické bezpečnosti (RIA, NCSC-EE) budou výzkumníci využívat data pro výzkum a rozvoj oborového a obecného benchmarku na národní úrovni.",
    "developers": "Principy rámce pro hodnocení vyspělosti (F4SLE) vyvinula Mari Seeba (UT, RIA). Měřicí nástroj (MASS) vyvinula Maria Pibilota Murumaa (UT, Cybernetica AS) pod vedením Mari Seeba a Tarmo Oja. Jako experti se zapojili Tarmo Oja (UT, Cybernetica AS), Václav Matyáš (MUNI) a Václav Stupka (MUNI). Měřicí projekt je mini-projektem výzkumné spolupráce v projektu CHESS v Estonsku a na jižní Moravě v České republice.",
    "disclaimer": "Financováno Evropskou unií na základě grantové dohody č. 101087529. Vyjádřené názory a stanoviska jsou však výhradně názory autora(ů) a nemusí nutně odrážet názory Evropské unie nebo Výkonné agentury pro výzkum. Evropská unie ani poskytovatel grantu za ně nenesou odpovědnost.",
    "evaluation": "Hodnocení vychází z Estonského standardu informační bezpečnosti (E-ITS https://eits.ria.ee), doporučení zprávy ENISA 2022 Threat Landscape Report (DOI: 10.2824/764318) a zahrnuje kontrolní cíle normy ISO 27002:2022.",
    "header": "Hodnocení úrovně informační bezpečnosti organizace",
    "principle_1": "* Podrobné odpovědi existují pouze v počítači respondenta, tedy ve vašem zařízení.",
    "principle_2": "* Pokud souhlasíte s odesláním agregovaných číselných hodnot úrovně vyspělosti vaší organizace na server, poskytneme vám také benchmark. Tento benchmark lze využít k porovnání výsledků vaší organizace s průměrnými výsledky jiných organizací (pokud jsou v daném okamžiku na serveru k dispozici).",
    "principle_3": "* Je možné uložit odpovědi do vašeho počítače (viz tlačítko Domů) a pokračovat v odpovídání později nebo si předchozí odpovědi znovu prohlédnout.",
    "principle_4": "* S vaším souhlasem budou na server odeslány pouze průměrné číselné hodnoty odpovědí a informace, které poskytnete o organizaci. Před odesláním na server si můžete přenášená data prohlédnout a uložit.",
    "principles": "Principy práce s nástrojem:",
    "processor": "Odpovědný správce dat:",
    "time_estimate": "Děkujeme vám za využití našeho nástroje k vyhodnocení vyspělosti řízení informační bezpečnosti vaší organizace. Vyplnění dotazníku a práce s nástrojem zabere přibližně 30–70 minut.",
    "ut": "Univerzita v Tartu"
  },
  "invalid_file": "Nahraný soubor není platný. Zkuste to znovu.",
  "language": "Výběr jazyka",
  "more_info": "Dodatečné informace",
  "new_questionnaire": "Začít nový dotazník",
  "next": "Další",
  "no_answer": "Nebudu odpovídat",
  "not_applicable": "Není relevantní",
  "orange": "Atribut je částečně v souladu s popisem situace, avšak stále s významnými nedostatky.",
  "red": "Pro dosažení stavu popsaného v atributu dosud nebylo učiněno nic významného.",
  "result_upload": "Otevřít existující soubor s výsledky z lokálního úložiště.",
  "results": {
    "PDF": "Vygenerovat PDF",
    "basic": "Slabá",
    "basic_description": "Postupy fungují a jsou zdokumentovány, zdroje jsou naplánovány a role a odpovědnosti jsou rozděleny. Doporučené činnosti však nejsou realizované konsistentně a pravidelně.",
    "basic_description2": "Pro řízení informační bezpečnosti byly zavedeny základní praktické činnosti.",
    "basic_range": ">=1.5 a <2.25 ",
    "benchmark_results": "Výsledky v porovnání s benchmarkem",
    "defined": "Omezená",
    "defined_description": "Doporučené procesy a činnosti jsou realizovány ad hoc. Dokumentace byla částečně vytvořena, ale je částečně zastaralá nebo neodpovídá skutečnosti.",
    "defined_description2": "Byly dohodnuty formální procesy a byly připraveny potřebné podpůrné dokumenty pro oblast informační bezpečnosti.",
    "defined_range": ">=0.75 a <1.5 ",
    "goal": "Cíl",
    "initial": "Výchozí",
    "initial_range": "<0.75 ",
    "initiated": "VÝCHOZÍ",
    "initiated_description": "Doporučené postupy nebyly zavedeny, rizika nebyla rozpoznána a vedení nepřevzalo iniciativu. Bezpečnostní činnosti jsou sporadické a spíše iniciované na úrovni zaměstnanců.",
    "initiated_description2": "Potřeba zabývat se informační bezpečností byla akceptována a řešena.",
    "maturity_levels": "Úrovně vyspělosti",
    "more": "Při odeslání zprůměrovaných číselných hodnot odpovědí do databáze se vedle výsledků vaší organizace zobrazí i zprůměrované výsledky ostatních organizací. Pro odeslání stiskněte následující tlačítko:",
    "process_dim": "Procesní dimenze",
    "results": "Výsledky",
    "save_local": "Uložit detailní odpovědi na lokální disk",
    "save_summary_local": "Uložit metadata shrnutí na lokální disk",
    "send_data": "Odeslat data na server a stáhnout benchmark",
    "standard": "Plná",
    "standard_description": "Organizační politiky a principy jsou jasné. Činnosti jsou monitorovány a dohledatelné, jsou standardizovány a zdokumentovány. Probíhá neustálé zlepšování. Výjimky jsou sledovány.",
    "standard_description2": "Existují jasné organizační politiky a principy. Činnosti jsou standardizované, zdokumentované, pravidelné a monitorované. Probíhá průběžné sledování a zlepšování.",
    "standard_range": ">2.25 ",
    "system_dim": "Systémové dimenze"
  },
  "send_results": {
    "back": "Zpět",
    "country": "Stát *",
    "czech": "Česká republika",
    "db_address": "Databázová adresa",
    "description": "Sběr zpětné vazby a dat",
    "domain": "Doména/sektor organizace *",
    "domain_list": {
      "ICT": "ICT",
      "chemicals": "Výroba a distribuce chemikálií",
      "digi": "Poskytovatelé digitálních služeb",
      "digital_service": "Digitální infrastruktura",
      "education": "Vzdělávání a výzkum",
      "energy": "Energetika",
      "finance": "Finanční sektor",
      "food": "Výroba, zpracování a distribuce potravin",
      "healthcare": "Zdravotnictví",
      "manufactoring": "Výorbní sektor",
      "municipality": "Obce",
      "non-profit": "Neziskový sektor",
      "other": "Ostatní",
      "postal": "Poštovní a kurýrní služby",
      "public_admin": "Veřejná správa",
      "space": "Vesmír",
      "transport": "Doprava",
      "waste": "Zpracování odpadu",
      "water_heating": "Ohrev vody a centrální vytápění"
    },
    "email": "E-mail (používá se pro oznámení, např. nový benchmark, dotazník)",
    "estonia": "Estonsko",
    "feedback": "Zpětná vazba",
    "home": "Domovská stránka",
    "info_sent": "Náhled informací zasílaných do databáze",
    "it_dep": "Počet osob zapojených do řízení informační bezpečnosti nebo IT v rámci organizace *",
    "it_dep_explanation": "Počet osob, které tráví 50 % nebo více svého času prací na řízení IT nebo informační bezpečnosti.",
    "loading": "Nahrávání",
    "more_info": "Principy zpracování dat najdete zde",
    "org_name": "Název organizace  *",
    "other_country": "Ostatní",
    "other_country_2": "Vložte zemi *",
    "other_domain": "Vložte doménu/sektor *",
    "other_role": "Vložte roli *",
    "refuse": "Nepřeji si účastnit se sběru dat",
    "role": "Vaše role v organizaci  *",
    "role_list": {
      "IT_manager": "IT manažer",
      "admin": "Administrativa/právník/pověřenec pro ochranu osobních údajů",
      "auditor": "Auditor",
      "info_manager": "Manažer/specialista informační bezpečnosti",
      "management": "Top management",
      "network": "Síťový/systémový administrátor",
      "other": "Ostatní"
    },
    "send": "Pošli výsledky",
    "send_database": "Výsledky odeslány do databáze",
    "standard": "Implementované standardy ve Vaší organizaci:",
    "standard_list": {
      "BSI": "BSI IT Grundshutz (Německo)",
      "CIS": "CIS Controls",
      "CzechAct": "Zákon o kybernetické bezpečnosti, č. 181/2014 Sb. (Česko)",
      "EITS": "E-ITS (Estonsko)",
      "ISKE": "ISKE (Estonsko)",
      "ISO": "ISO/IEC 27001",
      "KYTS": "KüTS (Estonsko)",
      "NIST": "NIST CSF"
    },
    "success": "Informace byly úspěšně zaslány do databáze!",
    "thank_you": "Díky za váš vstup!",
    "time": "Strávený čas",
    "time_estimate": "Čas strávený vyplňováním dotazníku *",
    "time_list": {
      "1_hour": "Přibližně 1 hodinu",
      "2_hours": "2 hodiny",
      "30_minutes": "Přibližně 30 minut",
      "4_hours": "2-4 hodiny",
      "8_hours": "4-8 hodin",
      "workday": "Více než jeden pracovní den"
    },
    "token": "Token",
    "validation": "Chybné nebo chybějící vstupy pro hodnoty:",
    "workplaces": "Počet zaměstnanců  *"
  },
  "to_start": "Zpět na úvodní stránku",
  "unexpected_error": "Neočekávaná chyba! Uložte prosím odpovědi na místní disk a zkuste to znovu později!",
  "unfinished_questionnaire": "Otevřít existující soubor s výsledky z lokálního úložiště.",
  "upload_file_text": "Prosím vyberte soubor .txt k otevření:",
  "version": "Verze dotazníku",
  "yellow": "Atribut je ve vaší organizaci řešen v přiměřené míře, avšak s určitými nedostatky."
}
